import { LoginBonus } from '../../../../../services/exports/Interfaces';
import useMobileApp from '../../../../../hooks/mobile-app/useMobileApp';
import toast from 'react-hot-toast';
import { LoginBonusHandler } from '../../../types';
import { useTranslation } from 'react-i18next';
import HelperMethods from '../../../../../services/exports/HelperMethods';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../../../../store/types';

const useMobileAppSignupBonus: LoginBonusHandler = () => {
  const { isMobileApp } = useMobileApp();
  const companyCurrency = useSelector((state: StoreInterface) => state.initialData.company?.currency);
  const { t } = useTranslation(null, { keyPrefix: 'Features:Auth:LoginBonusByKind' });
  const handle = (bonus: LoginBonus): void => {
    if (!isMobileApp) {
      return;
    }

    const amount = HelperMethods.formatCurrency(bonus.amount / 100, {
      currency: companyCurrency ?? 'EUR',
    });

    toast.success(t(`${bonus.kind}.toast`, { amount }));
  };

  return handle;
};

export default useMobileAppSignupBonus;
